import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import {routerReducer, routerMiddleware, connectRouter} from 'connected-react-router';
import 'firebase/auth'
import 'firebase/firestore'

import { initialState } from './reducers'

import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import rootSaga from './sagas';

const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware();
// const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, sagaMiddleware];

//eslint-disable-next-line
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancers = [
  applyMiddleware(...middlewares),
]

const reduxDevToolsExtension = window.devToolsExtension
if (
  process.env.NODE_ENV === "development" &&
  typeof reduxDevToolsExtension === "function"
) {
  enhancers.push(reduxDevToolsExtension())
}

const composedEnhancers = compose(...enhancers)

const store = createStore(combineReducers({...reducers}),
  initialState, composedEnhancers)
sagaMiddleware.run(rootSaga);


export { store, history };

// export default store